import { ColoursObj, Icon } from "@eventr/common-storybook";
import { useEffect, useRef } from "react";
import { ReactZoomPanPinchContentRef, TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { create } from "zustand";
import { useTopInset } from "../windowState/window.store";

interface IImageFrameStoreState {
  open: boolean;
  source: string | null;
}

interface IImageFrameStoreActions {
  openImageFrame: (source: string) => void;
  closeImageFrame: () => void;
}

export interface IImageFrameStore extends IImageFrameStoreState, IImageFrameStoreActions {}

const defaultImageFrameStore: IImageFrameStoreState = {
  open: false,
  source: null,
};

/**
 * Drawer Store
 * One drawer per instance
 */
export const useImageFrameStore = create<IImageFrameStore>((set) => ({
  ...defaultImageFrameStore,
  openImageFrame: (source: string) => {
    set({ open: true, source: source });
  },
  closeImageFrame: () => {
    set({ open: false, source: null });
  },
}));

type TImageFrameType = {
  open: boolean;
  imageSource?: string;
};

export const ImageFrame: React.FC<TImageFrameType> = ({ open, imageSource }) => {
  const topInset = useTopInset();
  const pinchRef = useRef<ReactZoomPanPinchContentRef | null>(null);
  useEffect(() => {
    if (pinchRef.current) {
      pinchRef.current.resetTransform();
    }
  }, [open]);
  return (
    <div
      style={{
        // Fixed to the viewport, not var(--app-width): in the two-pane layout that is only the
        // leading pane's width, so the preview used to open over the left pane alone.
        position: "fixed",
        inset: 0,
        zIndex: 1400,
        paddingTop: topInset,
        boxSizing: "border-box",
        backgroundColor: ColoursObj.shades.shade0,
        overflow: "hidden",
        display: open ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <TransformWrapper ref={pinchRef}>
        <TransformComponent wrapperStyle={{ overflow: "visible" }} contentStyle={{ height: "100%", width: "100%" }}>
          <img
            alt="header"
            style={{
              objectFit: "contain",
              height: `calc(100dvh - ${topInset}px)`,
              width: "100vw",
              // maxHeight: `calc(100vh -  ${windowSizes.value.insets.insets.top}px`,
              // maxWidth: '100vw',
            }}
            loading="lazy"
            src={imageSource}
          />
        </TransformComponent>
      </TransformWrapper>
      <div
        style={{
          position: "absolute",
          top: topInset,
          left: "0px",
          padding: "8px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={() => {
          // close
          useImageFrameStore.getState().closeImageFrame();
        }}
      >
        <div
          style={{
            padding: "4px",
            borderRadius: "24px",
            backgroundColor: ColoursObj.shades.shade0 + "20",
          }}
        >
          <Icon name="Exit" iconColour={ColoursObj.shades.shade5} />
        </div>
      </div>
    </div>
  );
};
